/**
 * Format hospital name for display — restores known acronyms to uppercase.
 * Internal API values stay title-cased (e.g., "Tmc - Kolkata") but display shows "TMC - Kolkata".
 *
 * @param {string} name - The title-cased hospital name from the API
 * @returns {string} - The display-friendly name with acronyms uppercased
 */

// Known acronyms that should remain uppercase
const ACRONYMS = [
  'TMC', 'HCG', 'AIIMS', 'ACTREC', 'KIMS', 'MGMC', 'MGM', 'MIOT',
  'MVR', 'PGI', 'SCH', 'SGPGI', 'SMBT', 'SUM', 'SUNACT', 'BALCO',
  'JIPMER', 'CTC', 'HIMS', 'HN', 'LH', 'PD', 'CIMS',
];

export function formatHospitalDisplay(name) {
  if (!name) return '';

  return name.replace(/\b\w+/g, (word) => {
    // Check if the word (uppercased) matches a known acronym
    const upper = word.toUpperCase();
    if (ACRONYMS.includes(upper)) return upper;
    return word;
  });
}
